<template>
  <div>
    <vxe-grid
      ref="table"
      auto-resize
      highlight-hover-row
      :toolbar-config="tableToolbar"
      :data="tableData"
      :columns="tableColumns"
      :loading="loading"
      :height="400"
      size="small"
      resizable
      border
      show-footer
      :checkbox-config="{
        highlight: true,
      }"
      @checkbox-change="onCheckboxChange"
      @checkbox-all="onCheckboxChange"
    >
      <template v-slot:toolbar_form>
        <slot name="header"></slot>
      </template>
      <template v-slot:containerAmount="{ row }">
        <span>{{ row.containerPriceAmount }}{{ row.v_currencyUnit }}</span>
      </template>
      <template v-slot:containerSalePrice="{ row }">
        <span
          >{{ row.containerSalePriceAmout }}{{ row.v_salesCurrencyUnit }}</span
        >
      </template>
      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">
            {{ $l('INDEX.tips_no_data') || '暂无数据！' }}
          </p>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import tableColumns from './table-columns'
export default {
  props: {
    tableData: { type: Array, default: () => [] },
    loading: { type: Boolean, default: false },
  },
  data() {
    return {
      tableToolbar: {
        slots: {
          buttons: 'toolbar_form',
        },
      },
      tableColumns: tableColumns(this),
    }
  },
  methods: {
    onCheckboxChange({ records }) {
      this.$emit('checkboxChange', records)
    },
  },
}
</script>
